/*
 *
 * OrderDetailsPage reducer
 *
 */

import { ContainerActions, ContainerState } from './types';

import ActionTypes from './constants';

export const initialState: ContainerState = {
  order: {
    items: [],
    supplier: {},
    creator: {},
    buyer: {},
    store: {},
    deliveryTime: {},
    loading: true,
    printOrderLoading: false,
    isStatusChange: false,
  },
};

function orderDetailsPageReducer(state: ContainerState = initialState, action: ContainerActions) {
  const { type, payload } = action as any;
  switch (type) {
    case ActionTypes.FETCH_ORDER_REQUEST:
      return {
        ...state,
        order: {
          items: [],
          supplier: {},
          creator: {},
          buyer: {},
          store: {},
          deliveryTime: {},
          loading: true,
          printOrderLoading: false,
          isStatusChange: false,
        },
      };
    case ActionTypes.FETCH_ORDER_SUCCESS:
    case ActionTypes.CONFIRM_ORDER_SUCCESS:
    case ActionTypes.APPROVE_ORDER_SUCCESS:
    case ActionTypes.DISAPPROVE_ORDER_SUCCESS:
    case ActionTypes.UPDATE_ORDER_SUCCESS:
    case ActionTypes.CANCEL_ORDER_SUCCESS:
    case ActionTypes.UPDATE_DELIVERY_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          ...payload,
          loading: false,
        },
      };
    case ActionTypes.FETCH_ORDER_FAILURE:
      return {
        ...state,
        order: {
          ...state.order,
          loading: false,
        },
      };
    case ActionTypes.PRINT_ORDER_INVOICE_REQUEST:
      return {
        ...state,
        order: {
          ...state.order,
          printOrderLoading: true,
        },
      };
    case ActionTypes.PRINT_ORDER_INVOICE_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          printOrderLoading: false,
        },
      };
    case ActionTypes.PRINT_ORDER_INVOICE_FAILURE:
      return {
        ...state,
        order: {
          ...state.order,
          printOrderLoading: false,
        },
      };
    case ActionTypes.CHECK_ORDER_STATUS_CHANGE:
      return {
        ...state,
        order: {
          ...state.order,
          isStatusChange: true,
        },
      };
    default:
      return state;
  }
}

export default orderDetailsPageReducer;
